import request from '@/utils/requestKU'
import requestFx from '@/utils/requestHkFx'
import { tokenurl, f10url, getwayurl, searchurl, auth, quanturl, getQuantAuthHeaders, getquotes, getQuotesapitrades } from './config'

type dataType = any

export default {


  // ⭐ 新增：获取港股简要详情
  getBriefDetail(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/stock/thshk/brief/detail`,
      method: 'get',
      params: data.data,
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },


  // ⭐ 最新动态-财务概况
  getBriefFinance(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/hk/stock/finance`,
      method: 'get',
      params: {
        ...data.data,
        indexCode: 'npParentCompanyOwners,operatingRevenue'
      },
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },
  // ⭐  高管介绍
  getBriefManagement(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/hk/stock/management`,
      method: 'get',
      params: {
        ...data.data,
      },
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },

  // ⭐  高管介绍 --- 美股
  getBriefManagementMg(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/us/stock/management`,
      method: 'get',
      params: {
        ...data.data,
      },
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },
  // ⭐  行业对比
  getBriefIndustryDetail(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/hk/stock/industry/rank/detail`,
      method: 'get',
      params: {
        ...data.data,
      },
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },
  // ⭐  股本
  getBriefsharesList(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/hk/stock/shares/list`,
      method: 'get',
      params: {
        ...data.data,
      },
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },
  // ⭐  股本变动 --- mg
  getBriefsharesListMg(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/us/stock/shares/list`,
      method: 'get',
      params: {
        ...data.data,
      },
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },

  // ⭐  主要股东
  getBriefshareholderList(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/hk/stock/main/shareholder/list`,
      method: 'get',
      params: {
        ...data.data,
      },
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },
  // ⭐  主要股东mg
  getBriefshareholderListMg(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/us/stock/main/shareholder/list`,
      method: 'get',
      params: {
        ...data.data,
      },
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },
  // ⭐  经营分析 - 主营介绍
  getBriefBriefManagement(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/stock/thshk/brief/management`,
      method: 'get',
      params: {
        ...data.data,
      },
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },
  // ⭐  经营分析 - 主营介绍 mg
  getBriefBriefManagementMg(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/us/stock/operating/income`,
      method: 'get',
      params: {
        ...data.data,
      },
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },

  // ⭐  公司行动 --分红派息 
  getBriefStockDividend(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/hk/stock/dividend`,
      method: 'get',
      params: {
        ...data.data,
      },
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },

  // ⭐  行业对比 
  getBriefRankDetail(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/hk/stock/industry/rank/detail`,
      method: 'get',
      params: {
        ...data.data,
      },
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },

  // ⭐  行业对比 ---mg
  getBriefRankDetailMg(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/us/stock/industry/rank/detail`,
      method: 'get',
      params: {
        ...data.data,
      },
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },



  // ⭐  最新动态-财务概况
  getBriefStockFinance(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/hk/stock/finance`,
      method: 'get',
      params: {
        ...data.data,
      },
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },
  // ⭐  最新动态-财务概况
  getBriefFinanceDividend(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/hk/stock/finance/dividend`,
      method: 'get',
      params: {
        ...data.data,
      },
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },

  // ⭐  财务概况- 1利润表，2负债表，3现金流量表，4主要指标
  getBriefFinanceDetail(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${quanturl}/fdzq/pc/rjhy-quote-news/api/1/hk/stock/finance/detail`,
      method: 'get',
      params: {
        ...data.data,
      },
      headers: {
        ...data.headers,
        appCode: 'com.fdzq.pc'
      },
      sign: true
    })
  },


  // 资讯公告 --新的接口
  getBriefAnnouncements(data: dataType): Promise<{ response?: Response }> {
    return requestFx({
      url: `${getquotes}/quotes/stock/announcements`,
      method: 'post',
      data: {
        ...data.data
      },
      headers: {
        ...data.headers,

        'Content-Type': 'application/x-www-form-urlencoded'
      },

    })
  },
  // 资讯公告 --新的接口Mg
  getBriefAnnouncementsMg(data: dataType): Promise<{ response?: Response }> {
    return requestFx({
      url: `${getquotes}/quotes/stock/announcements`,
      method: 'post',
      data: {
        ...data.data
      },
      headers: {
        ...data.headers,

        'Content-Type': 'application/x-www-form-urlencoded'
      },

    })
  },
  // 所属ETF --新的接口
  getBriefbaseInfo2(data: dataType): Promise<{ response?: Response }> {
    console.log('所属ETF 所属ETF ')
    return requestFx({
      url: `${getquotes}/quotes/stock/base_info2`,
      method: 'get',
      params: {
        ...data.data
      },
      headers: {
        ...data.headers,
        'Content-Type': 'application/x-www-form-urlencoded'
      },

    })
  },
  // 行情权限判定 --新的接口 行情权限判定
  getBriefIndexInfo(data: dataType): Promise<{ response?: Response }> {
    console.log('所属ETF 所属ETF ')
    return requestFx({
      url: `${getQuotesapitrades}/user/index/info`,
      method: 'GET',
      params: {
        ...data.data
      },
      headers: {
        ...data.headers,
        'Content-Type': 'application/x-www-form-urlencoded'
      },

    })
  },

  //  估值分析 --新的接口
  getBriefValuationAnalysis(data: dataType): Promise<{ response?: Response }> {

    return requestFx({
      url: `${getquotes}/api/activity_stock/valuation_analysis`,
      method: 'get',
      params: {
        ...data.data
      },
      headers: {
        ...data.headers,
        'Content-Type': 'application/x-www-form-urlencoded'
      },

    })
  },
  //  公司行动 -分拆合并、股票回购 --新的接口
  getBriefStockBaseDetail(data: dataType): Promise<{ response?: Response }> {
    return requestFx({
      url: `${getquotes}/quotes/stock/base_detail`,
      method: 'get',
      params: {
        ...data.data
      },
      headers: {
        ...data.headers,
        'Content-Type': 'application/x-www-form-urlencoded'
      },

    })
  }
}

